<template>
  <div class="page claim-page">
    <h2 class="page-title">泉井认领</h2>
    <div class="filter-card">
      <el-form :model="query" size="small" label-width="68px" class="filter-form">
        <el-row :gutter="12">
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="泉井名称"><el-input v-model="query.wellName" placeholder="输入泉井名称" clearable /></el-form-item>
          </el-col>
          <el-col :xl="5" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="认领人"><el-input v-model="query.keyword" placeholder="姓名/昵称/电话" clearable /></el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item label="审批状态">
              <el-select v-model="query.status" clearable placeholder="全部">
                <el-option label="待审核" :value="0" />
                <el-option label="认领通过" :value="1" />
                <el-option label="认领拒绝" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="10" :md="12" :sm="24" :xs="24">
            <el-form-item label="提交时间">
              <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" clearable />
            </el-form-item>
          </el-col>
          <el-col :xl="4" :lg="6" :md="8" :sm="12" :xs="24">
            <el-form-item class="filter-actions">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-card">
      <div class="table-toolbar">
        <span class="table-total">共 {{ total }} 条</span>
        <el-button size="small" @click="exportList">导出</el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="泉井名称" prop="wellName" min-width="150" show-overflow-tooltip />
        <el-table-column label="认领人" min-width="200">
          <template slot-scope="scope">
            <div class="user-cell">
              <el-avatar :size="32" :src="scope.row.avatar" icon="el-icon-user-solid" />
              <div class="user-info">
                <div class="user-nickname">{{ scope.row.nickname || '-' }}</div>
                <div class="user-realname">{{ scope.row.realName }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" width="140" />
        <el-table-column prop="reason" label="认领理由" min-width="220" show-overflow-tooltip />
        <el-table-column prop="rejectReason" label="审批备注" min-width="150" show-overflow-tooltip />
        <el-table-column label="提交时间" width="160">
          <template slot-scope="scope">{{ formatDate(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="claimTagType(scope.row.status)">{{ claimStatusText(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="action-bar">
              <span class="action-text view" @click="handleView(scope.row)">查看</span>
              <span class="action-text audit" :class="{ disabled: scope.row.status === 1 }" @click="scope.row.status !== 1 && auditGuardian(scope.row, 1)">通过</span>
              <span class="action-text reject" :class="{ disabled: scope.row.status === 2 }" @click="scope.row.status !== 2 && openReject(scope.row)">拒绝</span>
              <span class="action-text delete" @click="handleDelete(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, total" :total="total" :current-page.sync="query.pageNum" :page-size="query.pageSize" @current-change="loadData" style="margin-top:16px;text-align:right" />
    </div>

    <!-- 详情弹框 -->
    <el-dialog title="认领详情" :visible.sync="detailVisible" width="680px">
      <el-descriptions v-if="currentRow" :column="2" border size="small">
        <el-descriptions-item label="泉井名称">{{ currentRow.wellName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="认领状态"><el-tag :type="claimTagType(currentRow.status)">{{ claimStatusText(currentRow.status) }}</el-tag></el-descriptions-item>
        <el-descriptions-item label="昵称">{{ currentRow.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名">{{ currentRow.realName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ currentRow.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="提交时间">{{ formatDate(currentRow.createdAt) }}</el-descriptions-item>
        <el-descriptions-item label="认领理由" :span="2">{{ currentRow.reason || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审批备注" :span="2">{{ currentRow.rejectReason || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>

    <!-- 拒绝原因弹框 -->
    <el-dialog title="拒绝认领" :visible.sync="rejectVisible" width="460px">
      <el-form :model="rejectForm" label-width="80px">
        <el-form-item label="拒绝原因">
          <el-input v-model="rejectForm.remark" type="textarea" :rows="3" placeholder="请输入拒绝原因" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="danger" @click="submitReject">确认拒绝</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchClaims, auditClaim, deleteClaim } from '@/api'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      query: { pageNum: 1, pageSize: 10, wellName: '', keyword: '', status: undefined },
      detailVisible: false,
      rejectVisible: false,
      currentRow: null,
      rejectForm: { id: null, remark: '' }
    }
  },
  watch: {
    'query.wellName'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) },
    'query.keyword'() { this.handleSearch ? this.handleSearch() : (this.query && (this.query.pageNum=1), this.loadData()) }
  },

  created() { this.loadData() },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = { ...this.query }
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        Object.keys(params).forEach(k => { if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k] })
        const res = await fetchClaims(params)
        this.tableData = res.records || []
        this.total = res.total || 0
      } finally { this.loading = false }
    },
    handleSearch() { this.query.pageNum = 1; this.loadData() },
    handleReset() {
      this.dateRange = []
      this.query = { pageNum: 1, pageSize: 10, wellName: '', keyword: '', status: undefined }
      this.loadData()
    },
    handleView(row) { this.currentRow = row; this.detailVisible = true },
    async auditGuardian(row, status) {
      try {
        await this.$confirm('确认通过该认领申请吗？', '操作确认', { type: 'warning' })
        await auditClaim({ id: row.id, status, remark: '认领通过' })
        this.$message.success('认领已通过')
        this.loadData()
      } catch (e) {}
    },
    openReject(row) {
      this.rejectForm = { id: row.id, remark: row.rejectReason || '认领条件暂不符合' }
      this.rejectVisible = true
    },
    async submitReject() {
      if (!this.rejectForm.remark) { this.$message.warning('请填写拒绝原因'); return }
      await auditClaim({ id: this.rejectForm.id, status: 2, remark: this.rejectForm.remark })
      this.$message.success('已拒绝认领')
      this.rejectVisible = false
      this.loadData()
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除「${row.wellName}」的认领申请吗？`, '删除确认', { type: 'warning' })
        await deleteClaim(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (e) {}
    },
    exportList() {
      const headers = ['ID', '泉井名称', '昵称', '真实姓名', '联系方式', '认领理由', '审批备注', '提交时间', '状态']
      const rows = this.tableData.map(r => [r.id, r.wellName, r.nickname, r.realName, r.phone, r.reason, r.rejectReason, this.formatDate(r.createdAt), this.claimStatusText(r.status)])
      const csv = [headers, ...rows].map(items => items.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `认领申请_${new Date().toISOString().slice(0, 10)}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    claimStatusText(v) { return v === 1 ? '认领通过' : v === 2 ? '认领拒绝' : '待审核' },
    claimTagType(v) { return v === 1 ? 'success' : v === 2 ? 'danger' : 'warning' },
    formatDate(v) { return v ? String(v).replace('T', ' ').slice(0, 16) : '-' }
  }
}
</script>

<style scoped>
.filter-form ::v-deep .el-row { width: 100%; }
.filter-form ::v-deep .el-form-item { margin-bottom: 12px; }
.filter-form ::v-deep .el-input,
.filter-form ::v-deep .el-select,
.filter-form ::v-deep .el-date-editor { width: 100%; }
.filter-form ::v-deep .filter-actions .el-form-item__content { display: flex; gap: 8px; }
.table-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.table-total { font-size: 13px; color: #606266; }
.user-cell { display: flex; align-items: center; gap: 10px; }
.user-info { line-height: 1.5; }
.user-nickname { font-size: 13px; color: #303133; font-weight: 500; }
.user-realname { font-size: 12px; color: #909399; }
.action-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 10px; }
.action-text { cursor: pointer; font-size: 13px; }
.action-text:hover { text-decoration: underline; }
.action-text.view { color: #606266; }
.action-text.audit { color: #2f8f5b; }
.action-text.reject { color: #e6a23c; }
.action-text.delete { color: #f56c6c; }
.action-text.disabled { color: #c0c4cc; cursor: not-allowed; }
.action-text.disabled:hover { text-decoration: none; }
</style>
